import React from 'react';
import { Card, Form, Row, Col, Input } from 'antd';
import { Company } from '../../../../types/company.types';

interface BasicInfoFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  companyData: Partial<Company>;
  loading: boolean;
}

const BasicInfoForm: React.FC<BasicInfoFormProps> = ({ form, companyData, loading }) => (
  <Card className="setting-card" title="Temel Bilgiler">
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Şirket Adı"
          name="companyName"
          initialValue={companyData.name}
          rules={[{ required: true, message: 'Şirket adı zorunludur' }]}
        >
          <Input size="large" placeholder="Şirket adını giriniz" disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="E-posta"
          name="companyEmail"
          initialValue={companyData.email}
          rules={[
            { required: true, message: 'E-posta zorunludur' },
            { type: 'email', message: 'Geçerli bir e-posta adresi giriniz' }
          ]}
        >
          <Input size="large" placeholder="E-posta adresini giriniz" disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Telefon"
          name="companyPhone"
          initialValue={companyData.phone}
          rules={[{ required: true, message: 'Telefon numarası zorunludur' }]}
        >
          <Input size="large" placeholder="Telefon numarasını giriniz" disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Adres"
          name="companyAddress"
          initialValue={companyData.address}
          rules={[{ required: true, message: 'Adres zorunludur' }]}
        >
          <Input size="large" placeholder="Adresi giriniz" disabled={loading} />
        </Form.Item>
      </Col>
    </Row>
  </Card>
);

export default BasicInfoForm;
